export const OTHER_IMPOUND_CATEGORY_LABEL = 'Other';
